import { Device } from "../../../misc/api/DeviceLinkApi/Devices";
import * as GenericMessages from '../../../misc/api/DeviceLinkApi/GenericMessages';
import * as StatStripXpress2Api from '../../../misc/api/DeviceLinkApi/StatStripXpress2';
import * as StatStripXpressMessages from '../../../misc/api/DeviceLinkApi/StatStripXpress2Messages';
import { QueryOfBloodGlucoseSession, WebPortalClient } from "webportalclient";

export const StatStripXpress2CheckExistingData = async (webPortalClient: WebPortalClient, device: Device, raiseConfigurationError: (message: string, isWarning: boolean) => void): Promise<boolean> => {
    const fetchParentBloodGlucoseSessions = (serialNumber: string): Promise<QueryOfBloodGlucoseSession> => {
        return webPortalClient.getBloodGlucoseSessions(undefined, `deviceSerialNumber eq '${serialNumber}' and statusId eq 'BGSS_AWAITING_DATA'`, undefined, undefined, undefined, undefined, undefined, true);
    }

    const results = await StatStripXpress2Api.ApiGetResults(device.id);
    const sessions = await fetchParentBloodGlucoseSessions(device.serial);

    if (results.length > 0) {
        raiseConfigurationError(StatStripXpressMessages.TestsArePresentWarningMessage, true);
    }

    if (sessions["@odata.count"] > 0 && results.length > 0) {
        raiseConfigurationError(GenericMessages.DataExistBlockedConfigurationMessage, false);
        return false;
    } else if (sessions["@odata.count"] > 0) {
        raiseConfigurationError(StatStripXpressMessages.DeviceAlreadyConfiguredWarningMessage, true);
    }
    return true;
}
